export const t = {
  nav: {
    menu: { en: "Menu", es: "Menú" },
    story: { en: "Story", es: "Historia" },
    visit: { en: "Visit", es: "Visítanos" },
    order: { en: "Order Now", es: "Ordenar" },
  },
  hero: {
    scroll: { en: "Scroll to explore", es: "Desliza para explorar" },
    order: { en: "Order on DoorDash", es: "Ordenar en DoorDash" },
    viewMenu: { en: "View Menu", es: "Ver Menú" },
  },
  featured: {
    kicker: { en: "Crowd Favorites", es: "Favoritos" },
    title: { en: "The ones everyone comes back for", es: "Los que todos vuelven a pedir" },
  },
  menu: {
    kicker: { en: "Full Menu", es: "Menú Completo" },
    title: { en: "Made fresh, every single day", es: "Hecho fresco, todos los días" },
    priceNote: { en: "Prices as listed on DoorDash and may vary in-store.", es: "Precios según DoorDash; pueden variar en tienda." },
  },
  visit: {
    kicker: { en: "Come Say Hola", es: "Ven a Saludar" },
    title: { en: "Find us in Bay Shore", es: "Encuéntranos en Bay Shore" },
    address: { en: "Address", es: "Dirección" },
    hours: { en: "Hours", es: "Horario" },
    phone: { en: "Phone", es: "Teléfono" },
    directions: { en: "Get Directions", es: "Cómo llegar" },
  },
  footer: {
    rights: { en: "All rights reserved.", es: "Todos los derechos reservados." },
    admin: { en: "Admin", es: "Administrar" },
  },
};
